module.exports = __webpack_public_path__ + "img/empty.26589d51.png";